import React, { useContext } from 'react';
import styled from 'styled-components';
import { ThemeContext } from 'context/themeContext';
import Order from './order';

export const Tab = styled.div`
  position: relative;
  transition: height 300ms linear;
  background-color: ${(props) => props.theme.primaryBackground};
  height: ${(props) =>
    props.open && props.ordersCount !== 0
      ? props.ordersCount * 13.608 + 1.56 + 2.082 + 'vw'
      : '2.082vw'};
  width: 15.22vw;
  border-radius: 1.041vw;
  padding-left: ${(props) => (props.rtlDirection ? '0vw' : '1.04vw')};
  padding-right: ${(props) => (props.rtlDirection ? '1.04vw' : '0vw')};
  padding-top: 0.52vw;
  box-sizing: border-box;
  font-size: 0.728vw;
  color: ${(props) => props.theme.textPrimary};
`;

const InvoiceTab = (props) => {
  const { theme, rtlDirection } = useContext(ThemeContext);
  let content = [];
  props.orders.map((order) => {
    content.push(
      <Order
        notifications={props.notificationsByOrder[order._id]}
        onMouseDown={props.onMouseDown}
        top={props.top}
        left={props.left}
        order={order}
        onOrderClick={props.onOrderClick}
        link={props.link}
        isOrderModalOpen= {props.isOrderModalOpen}
      />
    );
  });

  return (
    <Tab
      theme={theme}
      onClick={props.onClick}
      ordersCount={props.ordersCount}
      open={props.open}
      rtlDirection={rtlDirection}
    >
      {props.children}
      {content}
    </Tab>
  );
};

export default InvoiceTab;
